<template>
    <main class="landing">

        <Header />

        <Hero />

        <LogoWall />

        <section class="features-intro">
            <h3 class="h3">
                Built for UXers,
                <span class="features-intro-highlight">
                    <span class="features-intro-highlight-text">approved</span>
                    <img :src="featuresIntroMarkerHighlight" alt="" />
                </span>
                <br>by those who hire them
            </h3>
        </section>

        <Features @signup-click="goToSignup($event)" />

        <MoreFeatures @signup-click="goToSignup('More features banner')" />

        <TestimonialSection />

        <PortfolioCustomization />

        <FaqSection @signup-click="goToSignup('FAQ')" />

        <TemplatesSection />

        <Footer />

        <CookieConsentBox />

    </main>
</template>

<script>
    import Header from "./publicPages/components/Header.vue";
    import Footer from "./publicPages/components/Footer.vue";
    import { useHead } from '@unhead/vue'
    import Hero from "./publicPages/components/Hero.vue";
    import Features from "./publicPages/components/Features.vue";
    import MoreFeatures from "./publicPages/components/MoreFeatures.vue";
    import TestimonialSection from "./publicPages/components/TestimonialSection.vue";
    import PortfolioCustomization from "./publicPages/components/PortfolioCustomization.vue";
    import FaqSection from "./publicPages/components/FaqSection.vue";
    import TemplatesSection from "./publicPages/components/TemplatesSection.vue";
    import LogoWall from "./publicPages/components/LogoWall.vue";
    import CookieConsentBox from "./publicPages/components/CookieConsentBox.vue";
    import {getLandingPageName, trackLandingCtaClick, trackLandingPageView} from "./publicPages/utilities/landingCtaTracking.js";
    import featuresIntroMarkerHighlight from "@/images/landing-media/marker-highlight-7.svg";
    import {registerTo} from "@/scripts/auth/keycloakAuth.js";

    let head = null;

    export default {
        name: "IndexPage",
        components: {
            Header,
            Footer,
            Hero,
            Features,
            MoreFeatures,
            TestimonialSection,
            PortfolioCustomization,
            FaqSection,
            TemplatesSection,
            LogoWall,
            CookieConsentBox,
        },
        data() {
            return {
                featuresIntroMarkerHighlight
            }
        },
        beforeMount() {
            document.documentElement.className = "light-mode";
        },
        mounted() {
            document.querySelector("html").classList.add("light--on");
            trackLandingPageView("Home");
            head = useHead({
                title: 'UXfolio - Build the UX portfolio that gets you hired'
            })
        },
        unmounted() {
            head.dispose();
        },
        methods: {
            goToSignup(section = "CTA section") {
                const utmCampaignSource = this.$route.fullPath === "/" ? "/landing" : this.$route.fullPath;

                trackLandingCtaClick("Sign up", getLandingPageName(this.$route.path), section, utmCampaignSource, {
                    destination: "/home/onboarding",
                });

                return registerTo('/home/onboarding', {
                    utm_source: utmCampaignSource,
                    utm_campaign: section,
                });
            }
        }
    }
</script>

<style lang="scss" global>
@import "@/styles/public-pages/reboot";
@import "@/styles/public-pages/general";
@import "@/styles/public-pages/components/header";
@import "@/styles/public-pages/components/footer";
@import "@/styles/public-pages/components/buttons";

.landing {
    ::selection {
        background: var(--Volt);
        color: black;
    }

    .logo {
        svg {
            path {
                fill: var(--color-text);
            }
        }
    }

    .features-intro {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 120px 24px 64px;
        text-align: center;

        .h3 {
            max-width: 640px;
            margin: 0;
        }

        .features-intro-highlight {
            position: relative;
            display: inline-block;
        }

        .features-intro-highlight-text {
            position: relative;
            z-index: 1;
        }

        .features-intro-highlight img {
            position: absolute;
            left: 50%;
            bottom: -0.26em;
            z-index: 0;
            width: 112%;
            height: 0.72em;
            max-width: none;
            transform: translateX(-50%);
            pointer-events: none;
        }
    }
}
</style>
